<template>
  <v-container class="text-top">
    <v-dialog
      v-model="calDialog"
      persistent
      max-width="800"
      transition="dialog-top-transition"
      :fullscreen="fullscreenValue"
    >
      <v-card>
        <v-toolbar color="primary" dark elevation="0">
          <v-toolbar-title>글쓰기</v-toolbar-title>

          <v-spacer></v-spacer>
          <v-btn icon @click="onCancelSubmit">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-text class="text-center">
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="baseItems.bor_name.value"
                  dense
                  outlined
                  hide-details
                  label="제목"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <ckeditor
                  v-model="editorData"
                  :config="editorConfig"
                ></ckeditor>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-card outlined tile>
              <v-row v-if="isUploading" dense>
                <v-col cols="12">
                  <v-toolbar elevation="0">
                    <template v-if="dessertscounr > 0">
                      <v-btn
                        small
                        class="mr-5"
                        outlined
                        rounded
                        color="primary"
                        @click="onFileExec('Download')"
                        >다운로드</v-btn
                      >
                      <v-btn
                        small
                        class="mr-5"
                        outlined
                        rounded
                        color="primary"
                        @click="onFileExec('Deleted')"
                        >삭제</v-btn
                      >
                    </template>
                    <v-spacer></v-spacer>
                    <v-btn
                      outlined
                      rounded
                      color="primary"
                      small
                      @click="$refs.fileInput.click()"
                    >
                      <v-icon left>mdi-pencil</v-icon> 파일선택
                    </v-btn>
                  </v-toolbar>
                  <input
                    ref="fileInput"
                    style="display: none"
                    multiple="multiple"
                    type="file"
                    @change="onFileSelected"
                  />
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    v-if="dessertscounr >= 0"
                    v-model="selected"
                    :mobile-breakpoint="0"
                    :headers="headers"
                    :items="desserts"
                    :items-per-page="5"
                    :single-select="singleSelect"
                    item-key="seq"
                    show-select
                    class="elevation-0"
                  >
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
        </v-form>

        <v-card-actions>
          <v-row>
            <v-col cols="3"> </v-col>
            <v-col cols="3">
              <v-btn
                block
                outlined
                rounded
                color="primary"
                @click="onCancelSubmit"
              >
                <v-icon>mdi-delete</v-icon> 취 소
              </v-btn>
            </v-col>
            <v-col cols="3">
              <v-btn
                block
                outlined
                rounded
                color="primary"
                @click="onSubmitSave"
              >
                <v-icon>mdi-pencil</v-icon> 등 록
              </v-btn>
            </v-col>
            <v-col cols="3"> </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
//import EventBus from "../EventBus";
import { mapActions, mapGetters } from "vuex"; // mapGetters를 추가한다

const register = "register";
const friends = "board";
export default {
  props: {
    propsOption: {
      type: String,
      default: null,
    },
    propsData: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  data() {
    return {
      calDialog: false,
      dialog: { Type: "", Head: "", Message: "" },

      baseItems: {
        bor_part: { value: "board", readonly: true, clearable: false },
        bor_key: { value: "", readonly: true, clearable: false },
        bor_name: { value: "", readonly: true, clearable: false },
        bor_details: { value: "", readonly: true, clearable: false },
        bor_file_status: { value: "", readonly: true, clearable: false },
        status: { value: "00", readonly: true, clearable: false },
      },
      valid: true,
      editorData: "",
      editorConfig: {
        language: "ko",
      },
      isUploading: false, // 파일 업로드 체크

      ///////////////////////
      // file

      headers: [
        {
          text: "name",
          sortable: false,
          value: "name",
          class: "blue lighten-5",
        },
        {
          text: "size",
          value: "size",
          class: "blue lighten-5",
        },
      ],

      // editedIndex: -1,
      desserts: [], // 파일 객체
      tmpDesserts: [], // 임시저장 파일 객체
      singleSelect: false,
      selected: [],
      dessertscounr: 0,
    };
  },
  computed: {
    ...mapGetters(register, {
      userID: "getUid",
    }),
    fullscreenValue() {
      console.log(
        "vuetify.breakpoint.name.....",
        this.$vuetify.breakpoint.name
      );
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        default:
          return false;
      }
    },
  },
  watch: {
    propsOption: function () {
      console.log("...watch dialogBoard propsOption:", this.propsOption);
      if (this.propsOption == "0001") {
        // this.propsOption1 = "0000";
        this.onSetDialog();
        this.$emit("prop-return", this.propsOption);
      }
      if (this.propsOption == "0003") {
        // this.propsOption1 = "0000";
        this.onSetEditDialog();

        this.$emit("prop-return", this.propsOption);
      }
    },
  },
  // created() {
  //   this.propsOption1 = "0001";
  // },
  mounted() {
    console.log(
      "vuetify.breakpoint.width.....",
      this.$vuetify.breakpoint.width
    );
  },
  methods: {
    ...mapActions(friends, ["BOARD_A", "BOARD_FILES"]),

    onCancelSubmit() {
      this.calDialog = false;

      console.log("props payload", this.calDialog);
    },
    async onBoardDataFetch(vbor_part, vbor_key, vstatus) {
      this.maxRow = 0;
      try {
        const boardResult = await this.BOARD_A({
          fun_code: "boardaSelectsFetch",
          bor_part: vbor_part,
          bor_key: vbor_key,
          status: vstatus,
        });
        if (boardResult.data.repCode === "00") {
          console.log("boardaSelectsFetch", boardResult);
          return boardResult.data.repDatas[0];
        } else {
          return boardResult.data.repDatas[0];
        }
      } catch (err) {
        this.dialogHead = "Error";
        this.dialogMessage = err;
        this.onMessageDisplay();
        console.error(err);
      }
    },
    async onBoardFilesFetch(vbor_part, vbor_key, vstatus) {
      this.maxRow = 0;
      try {
        const boardResult = await this.BOARD_A({
          fun_code: "boardFilesSelects",
          bor_part: vbor_part,
          bor_key: vbor_key,
          status: vstatus,
        });
        if (boardResult.data.repCode === "00") {
          console.log("boardFilesSelects", boardResult);
          return boardResult.data.repDatas;
        } else {
          return boardResult.data.repDatas[0];
        }
      } catch (err) {
        this.dialogHead = "Error";
        this.dialogMessage = err;
        this.onMessageDisplay();
        console.error(err);
      }
    },

    async onSubmitSave() {
      try {
        this.baseItems.bor_details.value = this.editorData;

        if (this.baseItems.bor_key.value === "") {
          this.fun_code = "boardaInsert";
        } else {
          this.fun_code = "boardaUpdate";
        }
        let userIDaa = this.userID;

        if (userIDaa == "") {
          userIDaa = "guest";
        }
        console.log("fun_code", this.fun_code);
        const boardResult = await this.BOARD_A({
          fun_code: this.fun_code,
          bor_part: this.baseItems.bor_part.value,
          bor_key: this.baseItems.bor_key.value,
          bor_name: this.baseItems.bor_name.value,
          bor_details: this.baseItems.bor_details.value,
          bor_file_status: this.baseItems.bor_file_status.value,
          status: this.baseItems.status.value,
          reg_id: userIDaa,
          chg_id: userIDaa,
        });
        if (boardResult.data.repCode === "00") {
          this.baseItems.bor_key.value = boardResult.data.repData.bor_key;
          const ilesResult = await this.onFileSave();
          this.onsetPropReturn();
        }
        console.log("boardResult", boardResult);
        this.dialog.Message = boardResult.data.repMessage;
        this.onMessageDisplay();
      } catch (err) {
        this.dialog.Head = "Error";
        this.dialog.Message = err;
        this.onMessageDisplay();
        console.error(err);
      }
    },

    onSetDialog() {
      this.isUploading = true;
      this.calDialog = this.propsData.dialogBoard.dialog;

      this.baseItems.bor_part.value = this.propsData.dialogBoard.bor_part;
      this.baseItems.bor_key.value = "";
      this.baseItems.bor_name.value = "";
      this.baseItems.bor_file_status.value = "";
      this.baseItems.status.value = this.propsData.dialogBoard.status;
      this.editorData = "";

      console.log("props onSetDialog", this.propsData.dialogBoard);
    },

    async onSetEditDialog() {
      this.calDialog = this.propsData.dialogBoard.dialog;
      this.baseItems.bor_part.value = this.propsData.dialogBoard.item.bor_part;
      this.baseItems.bor_key.value = this.propsData.dialogBoard.item.bor_key;
      this.baseItems.status.value = this.propsData.dialogBoard.item.status;

      console.log("props onSetboardData", this.baseItems);
      const [boardData, boardFiles] = await Promise.all([
        this.onBoardDataFetch(
          this.propsData.dialogBoard.item.bor_part,
          this.propsData.dialogBoard.item.bor_key,
          this.propsData.dialogBoard.item.status
        ),
        this.onBoardFilesFetch(
          this.propsData.dialogBoard.item.bor_part,
          this.propsData.dialogBoard.item.bor_key,
          this.propsData.dialogBoard.item.status
        ),
      ]);

      console.log("props onSetboardData", boardData);

      this.baseItems.bor_name.value = boardData.bor_name;
      this.editorData = boardData.bor_details;
      this.baseItems.bor_file_status.value = boardData.bor_file_status;

      this.onSetFiles(boardFiles);

      this.isUploading = true;
      if (!this.baseItems.bor_key.value) {
        this.isUploading = false;
      }

      console.log("isUploading", this.isUploading);
    },

    onMessageDisplay() {
      let payload = {
        Head: this.dialog.Head,
        Message: this.dialog.Message,
        dialog: true,
      };
      this.$emit("dialog-calendar", payload);
      console.log("onMessageDisplay", payload);
    },
    onsetPropReturn() {
      this.calDialog = false;
      let payload = {
        propsOption: "0005",
        message: "저장되었습니다.",
      };
      this.$emit("prop-return", payload);
    },
    // onsetPropReturn1(vlaue) {
    //   this.propsOption1 = "0000";
    //   this.files = vlaue.files;
    //   console.log("onsetPropReturn1", vlaue);
    // },
    ///////////////////////////////////////
    // file
    async onBoardFilesDelete(vfile) {
      console.log("onBoardFilesDelete", vfile);
      // this.maxRow = 0;

      let userIDaa = this.userID;

      if (userIDaa == "") {
        userIDaa = "guest";
      }
      try {
        const boardResult = await this.BOARD_A({
          fun_code: "boardFilesSetDelete",
          bor_file_key: vfile.orgName,
          bor_part: vfile.part,
          bor_key: vfile.key,
          del_status: "09", // delete
          status: "00", // delete
          reg_id: userIDaa,
          chg_id: userIDaa,
        });
        console.log("boardResult", boardResult);
        if (boardResult.data.repCode === "00") {
          console.log("boardResult", boardResult);
        }
      } catch (err) {
        this.dialogHead = "Error";
        this.dialogMessage = err;
        this.onMessageDisplay();
        console.error(err);
      }
    },

    onFileSelected(event) {
      // 선택된 파일이 있는가?
      if (0 < event.target.files.length) {
        let seq = this.desserts.length;
        const selectFiles = event.target.files;
        Array.from(selectFiles).forEach((file) => {
          const fileDetails = {
            seq: seq++,
            name: file.name,
            size: file.size,
            type: file.type,
            part: this.propsData.dialogBoard.bor_part,
            key: this.propsData.dialogBoard.bor_key,
            fileobject: file,
          };
          this.desserts.push(fileDetails);
        });
      }
      this.onFileCount(this.desserts);
      this.$refs.fileInput.value = null;
    },

    onFileExec(opt) {
      if (0 >= this.selected.length) {
        return;
      }

      switch (opt) {
        case "Download":
          this.selected.forEach((file) => {
            if (file.key) {
              console.log("Download", file);
              this.onFileDownload(file);
            }
          });
          break;

        case "Deleted":
          this.onFileDeleted();
          break;

        default:
      }

      this.selected = [];
      this.onFileCount(this.desserts);
    },

    onFileDeleted() {
      if (0 < this.selected.length) {
        this.selected.forEach((file) => {
          const index = this.desserts.indexOf(file);
          this.desserts.splice(index, 1);
          if (file.key) {
            console.log("Deleted", file);
            this.tmpDesserts.push(file);
          }
        });
      }
      this.selected = [];
      this.onFileCount(this.desserts);
    },

    onFileSave() {
      this.tmpDesserts.forEach((file) => {
        console.log("tmpDesserts  forEach ", file);
        if (file.key) {
          this.onBoardFilesDelete(file);
        }
      });

      let returnStatus = "";
      let userIDaa = this.userID;
      if (userIDaa == "") {
        userIDaa = "guest";
      }

      this.desserts.forEach((file) => {
        console.log("desserts  forEach ", file);
        if (!file.key) {
          let form = new FormData();
          form.append("fun_code", "boardFileUpload");
          form.append("bor_part", this.baseItems.bor_part.value);
          form.append("bor_key", this.baseItems.bor_key.value);
          form.append("status", this.baseItems.status.value);
          form.append("reg_id", userIDaa);

          console.log("Upload", file);
          form.append("upFile", file.fileobject); // api file name

          returnStatus = this.onfileUpload(form);
          console.log("returnStatus  forEach ", returnStatus);
          if (returnStatus.repCode !== "00") {
            return returnStatus;
          }
        }
      });
      return returnStatus;
    },

    async onfileUpload(form) {
      console.log("onfileUpload  ....... ", form);
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      try {
        const boardResult = await this.BOARD_FILES({
          fun_code: this.fun_code,
          form: form,
          config: config,
        });
        return boardResult.data;
      } catch (err) {
        this.dialogHead = "Error";
        this.dialogMessage = err;
        this.onMessageDisplay();
        console.error(err);
        this.isUploading = false;
      }
    },
    async onFileDownload(file) {
      const config = {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
        },
      };

      // const data = {
      //   fun_code: "boardFileDownload",
      //   bor_part: file.part,
      //   bor_key: file.key,
      //   bor_file_key: file.orgName,
      // };
      let userIDaa = this.userID;
      if (userIDaa == "") {
        userIDaa = "guest";
      }

      let form = new FormData();
      form.append("fun_code", "boardFileDownload");
      form.append("bor_part", file.part);
      form.append("bor_key", file.key);
      form.append("bor_file_key", file.orgName);

      form.append("status", "00");
      form.append("reg_id", userIDaa);
      try {
        const boardResult = await this.BOARD_FILES({
          form: form,
          config: config,
        });
        console.log("boardResult", boardResult);
        const blob = new Blob([boardResult.data], {
          type: "application/" + file.type,
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", file.name);
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        this.dialogHead = "Error";
        this.dialogMessage = err;
        this.onMessageDisplay();
        console.error(err);
        this.isUploading = false;
      }
    },

    onSetFiles(boardFiles) {
      let seq = 0;
      this.desserts = [];
      this.tmpDesserts = [];
      console.log("boardFiles", boardFiles);

      if (!boardFiles) {
        return;
      }
      Array.from(boardFiles).forEach((file) => {
        const fileDetails = {
          seq: seq++,
          name: file.bor_file_name,
          size: file.bor_file_size,
          type: file.bor_file_type,
          dir: file.bor_file_dir,
          part: file.bor_part,
          key: file.bor_key,
          orgName: file.bor_file_key,
        };
        this.desserts.push(fileDetails);
      });

      this.onFileCount(this.desserts);
    },

    onFileCount(vlaue) {
      this.dessertscounr = vlaue.length;
      let para = {
        propsOption: "0002",
        count: this.dessertscounr,
        files: this.desserts,
      };
      this.$emit("prop-return", para);
      console.log("onFileCount", para);
    },
  },
};
</script>
